import api from '../../services/api';
import { useQuery, useMutation } from "@tanstack/react-query";
import { success } from "../global/ToastAlert";
import { useGetVendorId } from "../global/User";

export const useGetProfile = () => {
    const vendorId = useGetVendorId()
    const fetchData = async () => {
        const { data } =  await api.get(`/vendors/${vendorId}/profiles/?vendorId=${vendorId}`)
        return data;
    };
    return useQuery({ queryKey: ['profiles'], queryFn: fetchData, enabled: true });
};

export const useUpdateProfile = (id) => {
    const vendorId = useGetVendorId();
    //const queryClient = useQueryClient();
    const updateData = async ({data:updateData, message=null}) => {
        const { data } = await api.post(`/vendors/${id}/profiles/?vendorId=${vendorId}`, updateData)     
        success(message);   
        return data;
    };
    return useMutation(updateData, {
        onSuccess: (data) => {
            //queryClient.invalidateQueries(['questions', moduleId]);
        },
    })
};
